import { Directive, HostListener, inject } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: '[appGoBack]',
  standalone: true,
})
export class GoBackDirective {
  private readonly location = inject(Location);

  @HostListener('click', ['$event.target.value'])
  onClick(): void {
    this.location.back();
  }
}
